import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorShowCache } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.adbWard;

export const getListWard = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const createADBWard = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const updateWard = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const removeWard = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getCacheWard = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const deployCacheWard = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
